/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/register.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for registration
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *      09/15/2018  NJN     Working on clean up to split out or eliminate code.
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    REGISTER_LOADED,
    REGISTER_UNLOADED,
    REGISTER_UPDATE_FIELD,
    REGISTER_CHECK_USERNAME,
    REGISTER_CHECK_EMAIL,
    REGISTER_CHECK_PASSWORD,
    REGISTER_ERROR,
    REGISTER_SUBMIT
} from '../constants/actionTypes';

const defaultState = {
    errors: null,
    username: '',
    email: '',
    password: '',
    password2: ''
};

// eslint-disable-next-line
export default (state = defaultState, action) => {
    switch (action.type) {
        case REGISTER_LOADED:
            return {
                ...state,
                inProgress: false
            }
        case REGISTER_CHECK_USERNAME:
            return {
                ...state
            }
        case REGISTER_CHECK_EMAIL:
            return {
                ...state
            }
        case REGISTER_CHECK_PASSWORD:
            return {
                ...state
            }
        case REGISTER_ERROR:
            console.log(action.payload)
            return {
                ...state,
                errors: {
                    ...state.errors,
                    ...action.payload
                }
            }
        case REGISTER_UPDATE_FIELD:
            return { ...state, [action.key]: action.value };
        case REGISTER_SUBMIT:
            return {
                ...state,
                inProgress: false
            }
        case REGISTER_UNLOADED:
            return {};
        default:
            return state;
    }
};
